import { TextCell } from "@similarweb/pro-logic-components";

const ROW_INDEX_COLUMN_WIDTH = 40;

export const rowIndexColumn = {
    key: "rowIndex",
    title: "",
    width: ROW_INDEX_COLUMN_WIDTH,
    render: (_value: unknown, _record: unknown, index: number) => (
        <TextCell fontVariant="body2">{index + 1}</TextCell>
    ),
};
